/* @ngInject */
export default function RouteConfig($stateProvider, $urlRouterProvider, $locationProvider, $analyticsProvider) {
    // (ajt 11/3/2015) - Added redirection for original /pipeline route.
    $urlRouterProvider
        .when('/pipeline', '/pipeline/leads')
        .when('/resources', '/resources/videos')
        .when('/certification', '/certification/courses')
        .when('/accounts', '/accounts/myprofile/')
        .otherwise('dashboard');

    $stateProvider
        .state('dashboard', {
            url: '/dashboard',
            template: require('../dashboard/dashboard.html'), // eslint-disable-line global-require
            controller: 'DashboardController',
            controllerAs: 'dashboard',
        })
        .state('todo', {
            url: '/todo',
            templateUrl: 'app/actionItems/actionItems.html',
        })
        .state('pipeline', {
            url: '/pipeline/:stageName',
            templateUrl: 'app/pipeline/pipeline.html',
            controller: 'PipelineController',
            controllerAs: 'pipeline',
        })
        .state('search', {
            url: '/search',
            template: require('../search/search.html'), // eslint-disable-line global-require
            controller: 'SearchController',
            controllerAs: 'search',
        })
        .state('resources', {
            url: '/resources/:resourceName',
            templateUrl: 'app/resources/resources.html',
            controller: 'ResourcesController',
            controllerAs: 'resources',
        })
        .state('certification', {
            url: '/certification/:certificationPage',
            templateUrl: 'app/certification/certification.html',
            controller: 'CertificationController',
            controllerAs: 'certification',
        })
        .state('accounts', {
            url: '/accounts/:accountsPage/:accountId',
            template: require('../accounts/accounts.html'), // eslint-disable-line global-require
            controller: 'AccountsController',
            controllerAs: 'accounts',
            params: {
                accountsPage: 'myprofile',
                accountId: null,
            },
        })
        .state('product-lookup', {
            url: '/product-lookup/:productLookupPage/:GeoState/:Id',
            templateUrl: 'app/productCenter/productCenter.html',
            controller: 'ProductCenterController',
            controllerAs: 'productCenter',
        })
        .state('lead', {
            url: '/lead/:prequalId',
            templateUrl: 'app/lead/lead.html',
            controller: 'LeadController',
            controllerAs: 'lead',
        })
        .state('app-detail', {
            url: '/app-detail/:appId',
            templateUrl: 'app/appDetail/appDetail.html',
            controller: 'AppDetailController',
            controllerAs: 'appDetail',
        })
        .state('ESign', {
            url: '/ESign/Result',
            templateUrl: 'app/appDetail/ESign/ESign.html',
            controller: 'ESignRedirectController',
            controllerAs: 'ESign',
        })
        .state('sso', {
            url: '/sso/:destination',
            templateUrl: 'app/common/topNav/sso.html',
            controller: 'SSOController',
            controllerAs: 'sso',
        })
        .state('httpError1', {
            url: '/httpError/:status',
            templateUrl: 'app/common/httpError/httpError.html',
        })
        .state('httpError2', {
            url: '/httpError/:status/:transactionId',
            templateUrl: 'app/common/httpError/httpError.html',
        })
        .state('esignature', {
            url: '/EsignatureDisclosure',
            templateUrl: 'app/common/footer/legalDocuments/legalDocuments.html',
        })
        .state('application', {
            url: '/application/:HEROId',
            templateUrl: 'app/application/application.html',
            controller: 'ApplicationController',
            controllerAs: 'application',
        });

    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
    });

    $locationProvider.hashPrefix('');

    $analyticsProvider.virtualPageviews(false);
}



// WEBPACK FOOTER //
// ./src/app/config/app.routes.js